import {AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Inject, OnDestroy, OnInit} from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import * as _ from 'lodash';
import { FacebookActionDao } from '../../../../core/services/dao/facebookActionDao';
import { IntegrationDao } from '../../../../core/services/dao/integrationDao';
import {User} from "../../../../core/models/user";
import {IntegrationInvite} from "../../../../core/models/integrationInvite";
import * as clip from 'copy-to-clipboard';
import {MatLegacySnackBar as MatSnackBar} from "@angular/material/legacy-snack-bar";

@Component({
  selector: 'facebook',
  templateUrl: './facebook.component.html',
  styleUrls: ['./facebook.component.scss']
})
export class FacebookComponent implements OnDestroy, OnInit, AfterViewInit {
  private subs = [];

  public loggedin = false;
  public connected = false;

  public adAccounts = [];
  public adAccount;
  private accessToken;
  private userId;

  public connecting = false;
  public creating = false;
  public existingIntegrations = [];
  public createdIntegration: any = {};

  private logincb;

  public user: User;
  public invites: IntegrationInvite[];
  public description: string = '';
  public showAccounts = false;
  public integrationName;
  public integrationType;
  public noAccounts;
  public isAdmin = false;
  private emitter: EventEmitter<any>;
  public advocadoAccountId = '1974168006175081';

  constructor(
    public dialogRef: MatDialogRef<FacebookComponent>,
    public integrationDao: IntegrationDao,
    public changeDetector: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public snackBar: MatSnackBar
  ) {
    this.existingIntegrations = this.data.existingIntegrations;
    this.user = this.data.user;
    this.isAdmin = this.user ? this.user.isAdmin : false;
    this.invites = this.data.invites.filter(i => i.integrations.includes(this.data.type));
    this.description = this.data.description;
    this.integrationName = this.data.name;
    this.integrationType = this.data.type;
    if (this.existingIntegrations.length === 0) {
      this.creating = true;
      this.noAccounts = true;
    }
    this.emitter = this.data.emitter;
  }

  ngOnInit(): void {
    if (this.creating) {
      this.logincb = this.onlogin.bind(this);
      window['FB'].Event.subscribe('auth.authResponseChange', this.logincb);
      window['FB'].getLoginStatus(res => {
        this.setLoggedIn(res);
      });
    }
  }

  onViewInvitesClick() {
    this.emitter.emit(this.integrationType);
    this.dialogRef.close();
  }

  copy() {
    clip(this.advocadoAccountId);
    this.snackBar.open('Account ID copied to clipboard', null, {
      duration: 1000,
      verticalPosition: 'top'
    });
  }

  ngAfterViewInit(): void {
    if (this.creating) {
      window['FB'].XFBML.parse();
    }
  }

  toggleShowAccounts() {
    this.showAccounts = !this.showAccounts;
  }

  ngOnDestroy() {
    this.subs.forEach(sub => sub.unsubscribe());
    window['FB'].Event.unsubscribe('auth.authResponseChange', this.logincb);
  }

  onlogin(res) {
    this.setLoggedIn(res);
  }

  setLoggedIn(res) {
    if (res && res.status && res.status === 'connected') {
      this.loggedin = true;
      this.accessToken = _.clone(res.authResponse.accessToken);
      this.userId = _.clone(res.authResponse.userID);
      this.checkPermissions().then(res => {
        let adsRead = res.some(item => item.permission === 'ads_read' && item.status === 'granted');
        let adsManage = res.some(item => item.permission === 'ads_management' && item.status === 'granted');
        if (adsRead && adsManage) {
          this.getAdAccounts(this.userId);
        } else {
          console.error('missing permissions');
          window['FB'].login(res => {}, {
            scope: 'ads_read,ads_management'
          } as any);
        }
      });
    } else {
      console.log('logged out');
      this.loggedin = false;
      this.adAccount = null;
      this.adAccounts = [];
      this.changeDetector.detectChanges();
    }
  }

  checkPermissions(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
    //   let sub = this.integrationDao.checkFbPermissions(this.userId, this.accessToken).subscribe(
    //     res => {
    //       resolve(res);
    //     },
    //     err => {
    //       console.error(err);
    //       reject(err);
    //     }
    //   );
    //   this.subs.push(sub);
    });
  }


  getAdAccounts(userId) {
    // let sub = this.integrationDao.getFbAdAccounts(userId, this.accessToken).subscribe(res => {
    //   if (res) {
    //     this.adAccounts = res;
    //   }
    //   this.changeDetector.detectChanges();
    // });
    // this.subs.push(sub);
  }

  addAnother(e) {
    this.creating = true;
    this.logincb = this.onlogin.bind(this);
    window['FB'].Event.subscribe('auth.authResponseChange', this.logincb);
    window['FB'].getLoginStatus(res => {
      this.setLoggedIn(res);
    });

    setTimeout(() => {
      if (this.creating) {
        window['FB'].XFBML.parse();
      }
    }, 0);
  }

  done() {
    this.connecting = true;
    this.createdIntegration.accessToken = this.accessToken;
    this.createdIntegration.userId = this.userId;
    this.createdIntegration.adAccountId = this.adAccount;
    let account = this.adAccounts.find(acct => acct.account_id === this.adAccount);
    this.createdIntegration.friendlyName = account.name;
    this.createdIntegration.type = 'facebook';
    this.createdIntegration.brand = this.data.brand;
    // let sub = this.integrationDao.createIntegration(this.createdIntegration).subscribe(
    //   res => {
    //     this.createdIntegration.id = res.id;
    //     this.createdIntegration.enabled = res.enabled;
    //     this.connecting = false;
    //     this.connected = true;
    //     this.dialogRef.close(this.createdIntegration);
    //   },
    //   err => console.error(err)
    // );
    // this.subs.push(sub);
  }
}
